import { render, staticRenderFns } from "./storage-instruction-one.vue?vue&type=template&id=efb00402"
import script from "./storage-instruction-one.vue?vue&type=script&lang=js"
export * from "./storage-instruction-one.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports